export function getItem(sessionItem: string) {
	const item = localStorage.getItem(sessionItem);
	if (!item && sessionItem === "token") {
		throw { response: { status: 401 } }; // if no token is found, emulate 401 response to redirect to login
	}
	return JSON.parse(item || "null");
}

export function setItem(sessionItem: string, value: any) {
	localStorage.setItem(sessionItem, JSON.stringify(value));
}

export function setSessionData(sessionData: { token?: string, user?: string }) {
	setItem('token', sessionData.token);
	setItem('user', sessionData.user);
	return true;
}

export function isActive() {
	let token = localStorage.getItem("token");
	if (token) {
		return true;
	}
	return false;
}

export function	clear() {
	localStorage.clear();
	return true;
}
